import React from 'react';

import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Heading from '@common/Heading';
import Img from '@common/Image';

import * as styles from './image-list.module.scss';

const ImageList = ({ data }) => {
  const {
    title,
    description,
    list
  } = data;
  return (
    <Section spacing='mb-3'>
      <Container>
        <Heading type='h2' className='mb-4 text-center'>{title}</Heading>
        <div className='d-flex flex-column align-items-center'>
          <div className='col-lg-8 mb-5'>
            <p className='text-center'>{description}</p>
          </div>
          {list &&
            <Row className='row-cols-md-2 gy-5 gx-3 mb-4'>
              {list.map((image, index) => (
                <div key={index} className='d-flex'>
                  <div className='position-relative d-flex flex-fill flex-column flex-lg-row align-items-center p-3 bg-white rounded'>
                    <div className={styles.imgPosition}>
                      <Img image={image.gatsbyImageData} file={image.file} className='rounded' />
                    </div>
                    <div className='col ms-lg-3 pt-2 pt-lg-0'>
                      {image.title && <p>{image.title}</p>}
                      {image.description && <p className='fs-16 mb-0'>{image.description}</p>}
                    </div>
                  </div>
                </div>
              ))}
            </Row>
          }
        </div>
      </Container>
    </Section>
  );
};

export default ImageList
